// ================================================================================
// history.js
// 成長の軌跡のスクリプトファイル
// ================================================================================

// 検索ページの比較
// --------------------------------------------------------------- //

window.addEventListener('pageshow', () => {





} );




